<div class="row">
  <div
    [ngClass]="[
      'col-12',
      controlIsDisabled('ContactMiddle') ? 'col-md-12' : 'col-md-8',
      'col-lg-4'
    ]"
  >
    <div class="mb-3">
      <label class="form-label" for="contactFirst">
        First Name
        <span *ngIf="controlIsRequired('ContactFirst')" class="color-error"
          >*</span
        >
      </label>
      <input
        class="form-control"
        id="contactFirst"
        placeholder="First name"
        type="text"
        [formControl]="getFormControl('ContactFirst')"
        aria-label="First name"
      />
    </div>
  </div>
  <div
    *ngIf="!controlIsDisabled('ContactMiddle')"
    class="col-6 col-md-4 col-lg-2"
  >
    <div class="mb-3">
      <label class="form-label" for="contactMiddle">
        MI
        <span *ngIf="controlIsRequired('ContactMiddle')" class="color-error"
          >*</span
        >
      </label>
      <input
        class="form-control"
        id="contactMiddle"
        placeholder="Middle Initial"
        type="text"
        [formControl]="getFormControl('ContactMiddle')"
        aria-label="Middle initial"
      />
    </div>
  </div>
  <div
    [ngClass]="[
      'col-12',
      controlIsDisabled('ContactSuffix') ? 'col-md-12' : 'col-md-8',
      'col-lg-4'
    ]"
  >
    <div class="mb-3">
      <label class="form-label" for="contactLast">
        Last Name
        <span *ngIf="controlIsRequired('ContactLast')" class="color-error"
          >*</span
        >
      </label>
      <input
        class="form-control"
        id="contactLast"
        placeholder="Last name"
        type="text"
        [formControl]="getFormControl('ContactLast')"
        aria-label="Last name"
      />
    </div>
  </div>
  <div
    *ngIf="!controlIsDisabled('ContactSuffix')"
    class="col-6 col-md-4 col-lg-2"
  >
    <div class="mb-3">
      <label class="form-label" for="contactSuffix">
        Suffix
        <span *ngIf="controlIsRequired('ContactSuffix')" class="color-error"
          >*</span
        >
      </label>
      <input
        class="form-control"
        id="contactSuffix"
        placeholder="Suffix"
        type="text"
        [formControl]="getFormControl('ContactSuffix')"
        aria-label="Suffix"
      />
    </div>
  </div>
</div>
